<template>
  <div class="gg-card-btn" @click="$emit('click')">
    <v-icon v-show="icon" :size="iconSize">{{ icon }}</v-icon>
    <span class="title">{{ label }}</span>
    <span v-show="description" class="description">{{ description }}</span>
  </div>
</template>

<script>
export default {
  name: 'GGCardBtn',
  props: {
    icon: {
      type: String,
      default: 'mdi-star',
    },
    iconSize: {
      type: [String],
      default: '2.5rem',
    },
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
  }
}
</script>
